/**
 * Function used to 24 hrs time format into 12 hour time format
 * @param time24 - 24hrs time string
 * @returns - 12 hrs time format
 */
function FormatUtcString(time24: string) {
  if (time24) {
    // Destructure hours and minutes directly from time24
    /* eslint-disable react/destructuring-assignment */
    const [hours24, minutes] = time24.split(':').map(Number);

    // Determine the period (AM/PM)
    const period = hours24 >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    const hours12 = hours24 % 12 || 12;

    // Return the formatted time
    return `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
  }
  return null;
}

/**
 * Function to return UTC string in YYYY-MM-DD format
 * @param utcString 
 * @returns 
 */
function extractDateFromUTC(utcString: string) {
  // Parse the UTC string into a Date object
  const date = new Date(utcString);

  // Extract the year, month, and day
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const day = String(date.getUTCDate()).padStart(2, '0');

  // Return the date in YYYY-MM-DD format
  return `${year}-${month}-${day}`;
}

export { FormatUtcString, extractDateFromUTC };
